import { render, staticRenderFns } from "./PhotoAnnotator.vue?vue&type=template&id=248082d6"
import script from "./PhotoAnnotator.vue?vue&type=script&lang=js"
export * from "./PhotoAnnotator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports